module.exports = __webpack_public_path__ + "img/avatar-s-1.680013ab.jpg";